<template>
  <div>
    <header-component/>

    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 
            class="mb-0" 
            style="text-transform:capitalize;">Service List</h3>
          <div class="text-right">
            <el-select
              v-model="categoryId"
              filterable
              clearable
              placeholder="Service Category"
              size="small"
              class="mr-2"
              style="width: 220px;"
            >
              <el-option
                v-for="item in serviceCategories"
                :key="item.serviceCategoryId"
                :label="item.label"
                :value="item.serviceCategoryId"
              />
            </el-select>
            <base-button 
              size="sm" 
              type="primary" 
              @click="createService">Add New</base-button>
          </div>
        </div>
        <el-table
          :data="sortedServiceList"
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
        >
          <el-table-column 
            label="Name" 
            prop="label"/>
          <el-table-column
            label="Service Category Name"
            min-width="160px"
          >
            <template slot-scope="scope">
              {{ serviceCategoryLabels(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column min-width="70px">
            <template slot-scope="scope">
              <el-dropdown slot="dropdown" @command="command => handleAction(scope.row, command)">
                 <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                  <el-dropdown-item command="delete" style="color: #f56c6c">Delete</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        :visible.sync="addService" 
        title="Add Service">
        <add-service @close="addService = false"/>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import AddService from "./AddService";
import headerComponent from "../Components/HeaderComponent";
import Api from "@/middleware/api";
import endpoints from "@/utils/constants";

export default {
  data: () => {
    return {
      addService: false,
      categoryId: null
    };
  },

  computed: {
    ...mapGetters({
      serviceList: "service/getServiceList",
      service: "service/getService",
      serviceCategories: "serviceCategory/getServiceCategoryList"
    }),
    sortedServiceList() {
      return [...(this.serviceList || [])]
        .filter(row => !this.categoryId || this.categoryIdsOf(row).indexOf(this.categoryId) !== -1)
        .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
    }
  },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name] : Button,
    "add-service": AddService,
    "header-component": headerComponent
  },

  mounted() {
    this.getServiceList();
    this.getServiceCategoryList();
  },

  methods: {
    ...mapActions({
      getServiceList: "service/getServiceList",
      fetchService: "service/fetchService",
      getServiceCategoryList: "serviceCategory/getServiceCategoryList"
    }),
    ...mapMutations({
      setService: "service/setService",
      resetService: "service/resetService"
    }),
    handleAction(service, command) {
      if (command === "edit") {
        this.fetchService(service.serviceId).then(res => {
          this.addService = true;
          this.setService(res);
        });
      } else if (command === "delete") {
        if (!window.confirm("Delete this service?")) return;
        new Api().call("delete", `${endpoints.LARAVEL_BASE_URL}/api/v1/services/${service.serviceId}`)
          .then(() => {
            this.getServiceList();
            window.notify && window.notify({ message: "Deleted", type: "success", title: "Success" });
          })
          .catch(() => {
            window.notify && window.notify({ message: "Failed to delete", type: "danger", title: "Error" });
          });
      }
    },

    categoryIdsOf(row) {
      if (row.serviceCategoryIds && row.serviceCategoryIds.length) return row.serviceCategoryIds;
      return row.serviceCategoryId ? [row.serviceCategoryId] : [];
    },

    serviceCategoryLabels(row) {
      if (row.serviceCategories && row.serviceCategories.length) {
        const labels = row.serviceCategories.map(category => category.label).filter(Boolean);
        if (labels.length) return labels.join(", ");
      }
      return (row.serviceCategory && row.serviceCategory.label) || "";
    },

    createService() {
      this.resetService();
      this.addService = true;
    }
  }
};
</script>
